import { Injectable } from '@angular/core';
import { AngularFirestore, QueryFn } from '@angular/fire/compat/firestore';
import { firstValueFrom } from 'rxjs';

import UniqueEntityID from '../../../core/domain/unique_entity_id';
import { UrlTargeting } from '../domain/url-targeting';

export class UrlTargetingSchema {
  url: string;
  label: string;
  target: string;
}

@Injectable()
export class UrlTargetingRepository {
  constructor(private firestore: AngularFirestore) {
    // do nothing
  }

  private collection(queryFn?: QueryFn) {
    return this.firestore.collection<UrlTargetingSchema>(
      'url_targeting',
      queryFn,
    );
  }

  public toSchema(entity: UrlTargeting): UrlTargetingSchema {
    return <UrlTargeting>{
      url: entity.url,
      label: entity.label,
      target: entity.target,
    };
  }

  public fromSchema(schema: UrlTargetingSchema, id?: string): UrlTargeting {
    return UrlTargeting.create(
      {
        url: schema.url,
        label: schema.label,
        target: schema.target,
      },
      new UniqueEntityID(id),
    );
  }

  public async findAll(): Promise<UrlTargeting[]> {
    try {
      const rs = await firstValueFrom(this.collection().get());
      return rs.docs.map((doc) => this.fromSchema(doc.data(), doc.id));
    } catch (e) {
      console.error('🔴 UrlTargetingRepository.findAll', e);
      throw e;
    }
  }
}
